var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('p',{staticClass:"title is-2"},[_vm._v("Categorías")]),_c('b-tabs',{attrs:{"size":"is-medium"},model:{value:(_vm.tabActiva),callback:function ($$v) {_vm.tabActiva=$$v},expression:"tabActiva"}},[_c('b-tab-item',{attrs:{"label":"Categorías","icon":"archive"}},[_c('categorias-component')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }